/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTime200Response
 */
export interface GetTime200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTime200Response
     */
    time: string;
}

/**
 * Check if a given object implements the GetTime200Response interface.
 */
export function instanceOfGetTime200Response(value: object): value is GetTime200Response {
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function GetTime200ResponseFromJSON(json: any): GetTime200Response {
    return GetTime200ResponseFromJSONTyped(json, false);
}

export function GetTime200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTime200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'time': json['time'],
    };
}

export function GetTime200ResponseToJSON(json: any): GetTime200Response {
    return GetTime200ResponseToJSONTyped(json, false);
}

export function GetTime200ResponseToJSONTyped(value?: GetTime200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'time': value['time'],
    };
}

